import { useQuery } from 'react-query';

import { DonationInquiry } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';


export const getDonationInquiry = async (): Promise<DonationInquiry[]> => {
    const { data } = await axios.get(`v1/get-donation-inquiries`);
    return data.inquiries;
};

type QueryFnType = typeof getDonationInquiry;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useDonationInquiry = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['donationInquiry'],
        queryFn: () => getDonationInquiry(),
    });
};
